export const EGG_REWARD_EVENT = "ga-egg-reward";
export const EGG_REWARD_CLOSED_EVENT = "ga-egg-reward-closed";

const BASELINE_KEY = "ga_claimed_reward_baseline";

function readBaseline() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(BASELINE_KEY) || "null");
    return Array.isArray(parsed) ? parsed.map(String) : null;
  } catch {
    return null;
  }
}

function writeBaseline(ids) {
  try {
    sessionStorage.setItem(BASELINE_KEY, JSON.stringify([...new Set(ids.map(String))]));
  } catch {
    /* ignore quota */
  }
}

export function rewardTaskId(task) {
  if (!task) return "";
  return String(task.taskKey || task.task_key || `${task.type || ""}:${task.title || ""}`);
}

export function rememberClaimedRewards(tasks) {
  if (readBaseline()) return;
  const ids = (tasks || []).filter((task) => task?.claimed).map(rewardTaskId).filter(Boolean);
  writeBaseline(ids);
}

export function hasRewardBaseline() {
  return readBaseline() != null;
}

export function claimedRewardIsNew(task) {
  const id = rewardTaskId(task);
  if (!id) return false;
  const baseline = readBaseline();
  if (!baseline) return false;
  return !baseline.includes(id);
}

export function markRewardSeen(taskOrId) {
  const id = typeof taskOrId === "string" ? taskOrId : rewardTaskId(taskOrId);
  if (!id) return;
  const baseline = readBaseline();
  if (!baseline) {
    writeBaseline([id]);
    return;
  }
  if (baseline.includes(id)) return;
  writeBaseline([...baseline, id]);
}

export function announceEggReward({
  title,
  rewardEggs,
  eggBalance,
  taskKey,
  source,
} = {}) {
  const amount = Math.max(0, Number(rewardEggs) || 0);
  if (!amount || typeof window === "undefined") return;

  if (taskKey) markRewardSeen(String(taskKey));

  window.dispatchEvent(
    new CustomEvent(EGG_REWARD_EVENT, {
      detail: {
        title: title ? String(title) : "",
        rewardEggs: amount,
        eggBalance:
          eggBalance == null || eggBalance === "" ? null : Number(eggBalance),
        taskKey: taskKey ? String(taskKey) : "",
        source: source ? String(source) : "",
      },
    })
  );
}
